module.exports = __webpack_public_path__ + "img/3-image4.10bb8019.png";